import { Pipe, PipeTransform } from '@angular/core';

/**
 * Készlet-kiemelés a Stokker design pill színeivel:
 * - zöld:  a készlet eléri a limitet
 * - sárga: a készlet a limit alatt, de több mint a fele
 * - piros: a készlet legfeljebb a limit fele (vagy elfogyott)
 */
@Pipe({
  name: 'stockHighlightClass'
})
export class StockHighlightPipe implements PipeTransform {
  transform(item: any, isChild: boolean = false): any {
    // Null-védelem: a recept-gyerek soraiban a component_child hiányozhat,
    // ilyenkor ne dobjunk hibát a sablonban.
    const limit = (isChild ? item?.component_child?.limit : item?.limit) ?? 0;
    if (item.stock >= limit) {
      return 'stk-pill--green';
    } else if (item.stock < limit && item.stock > limit * 0.5) {
      return 'stk-pill--yellow';
    } else {
      return 'stk-pill--red';
    }
  }
}
